import React from 'react';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const blogPosts = [
  {
    slug: "tables-chairs-conversations",
    title: "Tables, Chairs & Conversations: Designing the Heart of the Home",
    excerpt: "Discover how thoughtful design choices can transform your daily rituals into moments of mindfulness.",
    category: "Furniture Guide",
    date: "June 12, 2023",
    image: "/Blogs_1.png",
  },
  {
    slug: "japanese-minimalism-scandinavian-comfort",
    title: "Japanese Minimalism Meets Scandinavian Comfort",
    excerpt: "Explore how two distinct design philosophies can harmonize to create serene yet inviting spaces.",
    category: "Design Fusion",
    date: "May 28, 2023",
    image: "/Blogs_2.png",
  },
  {
    slug: "perfect-bedroom-retreat",
    title: "Creating the Perfect Bedroom Retreat",
    excerpt: "Learn the essential elements that transform an ordinary bedroom into a sanctuary for rest and renewal.",
    category: "Room Guide",
    date: "May 15, 2023",
    image: "/Blogs_3.png",
  },
];

export default function Blog() {
  return (
    <div className="min-h-screen bg-white">
      <section className="bg-stone-50 py-24">
        <div className="container mx-auto px-4">
          <motion.h1
            className="mb-3 text-center font-serif text-4xl font-light md:text-5xl"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            style={{ fontFamily: 'serif' }}
          >
            Inspiration You Can Live In
          </motion.h1>

          <motion.p
            className="mx-auto mb-12 max-w-2xl text-center text-gray-600 text-lg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Explore our journal for design insights, home styling tips, and artisanal stories.
          </motion.p>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {blogPosts.map((post, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10 }}
                className="h-full"
              >
                <div className="h-full bg-white rounded-lg shadow-lg overflow-hidden border-none">
                  <div className="relative h-64 w-full overflow-hidden">
                    <img
                      src={post.image || "/placeholder.svg"}
                      alt={post.title}
                      className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                    />
                  </div>

                  <div className="p-6">
                    <div className="mb-3 flex items-center justify-between">
                      <span className="text-xs font-medium uppercase tracking-wider text-amber-700">{post.category}</span>
                      <span className="text-xs text-gray-500">{post.date}</span>
                    </div>

                    <h2 className="mb-3 font-serif text-xl font-medium leading-tight" style={{ fontFamily: 'serif' }}>{post.title}</h2>
                    <p className="mb-4 text-gray-600 leading-relaxed">{post.excerpt}</p>

                    <Link 
                      to={`/blog/${post.slug}`}
                      className="group p-0 text-amber-700 inline-flex items-center font-medium hover:text-amber-800 transition-colors"
                    >
                      Read More 
                      <svg 
                        className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </Link>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}